import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";

export const initTestimonialsSwiper = () => {
  const testimonialsElement = document.querySelector(".testimonials-swiper");
  if (!testimonialsElement) return;

  // Helper function to manage slide accessibility
  const updateSlideAccessibility = (swiper: any) => {
    const slides = swiper.slides;
    const visibleIndexes: number[] =
      swiper.visibleSlidesIndexes?.length
        ? swiper.visibleSlidesIndexes
        : (() => {
            const slidesPerViewParam = swiper.params.slidesPerView;
            const slidesPerView =
              typeof slidesPerViewParam === 'number'
                ? slidesPerViewParam
                : swiper.slidesPerViewDynamic();
            const start = swiper.activeIndex ?? 0;
            const end = start + (slidesPerView || 1);
            return Array.from({ length: Math.ceil(end - start) }, (_, i) => start + i);
          })();
    const visibleSet = new Set(visibleIndexes);

    slides.forEach((slide: HTMLElement, index: number) => {
      const isVisible = visibleSet.has(index);

      // Select all naturally focusable elements within the slide
      const focusableElements = slide.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      // Filter out navigation buttons (they should not be affected)
      const slideContentElements = Array.from(focusableElements).filter((el: Element) => {
        return (
          !el.classList.contains('testimonials-button-prev') &&
          !el.classList.contains('testimonials-button-next') &&
          !el.classList.contains('swiper-pagination-bullet')
        );
      });

      // Update tabindex and aria-hidden for slide content
      slideContentElements.forEach((el: Element) => {
        if (isVisible) {
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-hidden', 'true');
        }
      });

      // Update the slide itself
      if (isVisible) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const testimonials_swiper = new Swiper(".testimonials-swiper", {
    modules: [Pagination, Navigation, A11y],
    spaceBetween: 16,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    loop: false,
    centeredSlides: false,
    watchOverflow: false,
    pagination: {
      el: ".testimonials-swiper .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".testimonials-button-next",
      prevEl: ".testimonials-button-prev",
    },
    a11y: {
      enabled: true,
      prevSlideMessage: (window as any).TestimonialSwiperTranslations?.prevSlideMessage,
      nextSlideMessage: (window as any).TestimonialSwiperTranslations?.nextSlideMessage,
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: (window as any).TestimonialSwiperTranslations?.paginationBulletMessage,
    },
    breakpoints: {
      // Mobile: ~1.3 testimonials (fixed card width)
      640: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesPerGroup: 1,
          loop: false,

      },
      // Tablet: 2 testimonials
      848: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesPerGroup: 1,
          loop: false,

      },
      // Desktop: 3 testimonials
      1024: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4,
        slidesOffsetBefore: -100,
        // slidesOffsetAfter: 144,
      },
    },
    on: {
      init: function() {
        // Small delay to ensure DOM is fully rendered
        setTimeout(() => updateSlideAccessibility(this), 100);

        // Prevent scroll when using keyboard on pagination bullets
        const paginationBullets = document.querySelectorAll('.testimonials-swiper .swiper-pagination-bullet');
        paginationBullets.forEach((bullet) => {
          bullet.addEventListener('keydown', (e: Event) => {
            const keyEvent = e as KeyboardEvent;
            if (keyEvent.key === ' ' || keyEvent.key === 'Enter') {
              e.preventDefault();
              (bullet as HTMLElement).click();
            }
          });
        });
      },
      slideChange: function() {
        updateSlideAccessibility(this);
      },
      breakpoint: function() {
        // Update accessibility when breakpoint changes
        setTimeout(() => updateSlideAccessibility(this), 100);
      },
      resize: function() {
        setTimeout(() => updateSlideAccessibility(this), 100);
      },
    },
  });
};
